/**
 * Check Detail Modal Configuration
 * Badge class helpers extracted from CheckDetailModal.tsx
 */

import { CDDCheck } from "../../../../types/cdd-records.types";

export const getStatusBadgeClass = (status: CDDCheck["status"]): string => {
	switch (status) {
		case "completed":
			return "bg-gradient-to-r from-emerald-100 to-green-100 text-emerald-800 shadow-sm";
		case "in-progress":
			return "bg-gradient-to-r from-blue-100 to-indigo-100 text-blue-800 shadow-sm";
		case "failed":
			return "bg-gradient-to-r from-rose-100 to-red-100 text-rose-800 shadow-sm";
		case "pending":
			return "bg-gradient-to-r from-amber-100 to-yellow-100 text-amber-800 shadow-sm";
		default:
			return "bg-gradient-to-r from-slate-100 to-gray-100 text-slate-700 shadow-sm";
	}
};

export const getResultBadgeClass = (result?: CDDCheck["result"]): string => {
	switch (result) {
		case "pass":
			return "bg-gradient-to-r from-emerald-100 to-green-100 text-emerald-800 shadow-sm";
		case "fail":
			return "bg-gradient-to-r from-rose-100 to-red-100 text-rose-800 shadow-sm";
		case "review-required":
			return "bg-gradient-to-r from-orange-100 to-amber-100 text-orange-800 shadow-sm";
		case "inconclusive":
			return "bg-gradient-to-r from-amber-100 to-yellow-100 text-amber-800 shadow-sm";
		default:
			return "bg-gradient-to-r from-slate-100 to-gray-100 text-slate-700 shadow-sm";
	}
};
